export const initFbsdk = () => {
  return new Promise(resolve => {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: '1440065933015291',
        cookie: true, // enable cookies to allow the server to access the session
        xfbml: true, // parse social plugins on this page
        version: 'v2.8' // use graph api version 2.8
      })
      resolve();
    }(function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) return
      js = d.createElement(s); js.id = id
      js.src = '//connect.facebook.net/en_US/all.js'
      fjs.parentNode.insertBefore(js, fjs)
    }(document, 'script', 'facebook-jssdk'))
  })
}


// function initFbSdk(options) {
//   return new Promise(resolve => {
//     window.fbAsyncInit = function () {
//       const defaults = { cookie: true, xfbml: true }
//       options = { ...defaults, ...options }
//       window.FB.init(options)
//       resolve()
//     };
//     /* eslint-disable */
//     (function (d, s, id) {
//       const fjs = d.getElementsByTagName(s)[0]
//       if (d.getElementById(id)) { return; }
//       const js = d.createElement(s); js.id = id
//       js.src = '//connect.facebook.net/zh_TW/sdk.js'
//       fjs.parentNode.insertBefore(js, fjs)
//     }(document, 'script', 'facebook-jssdk'))
//     /* eslint-enable */
//   })
// }